'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'joystick';
var width = 448;
var height = 512;
var aliases = [128377];
var unicode = 'f8c5';
var svgPathData = 'M224 0c61.9 0 112 50.1 112 112 0 53.6-37.7 98.4-88 109.4l0 130.6 200 0 0 160-448 0 0-160 200 0 0-130.6c-50.3-11-88-55.8-88-109.4 0-61.9 50.1-112 112-112zM48 464l352 0 0-64-352 0 0 64zM224 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJoystick = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;